export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="w-full lg:w-2/5 shrink-0">
            <span className="inline-block px-3 py-1 rounded-full border border-accent-300/50 bg-accent-100/60 text-accent-700 text-xs font-medium mb-5">
              Shopping Guide
            </span>
            <div
              className="w-full aspect-[4/5] rounded-3xl bg-cover bg-center"
              style={{
                backgroundImage: `url('https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20open%20spiral%20notebook%20pen%20and%20fashion%20catalog%20magazine%20spread%20on%20light%20wood%20coffee%20table%20soft%20afternoon%20sunlight%20filtered%20through%20linen%20curtains%20creating%20warm%20dappled%20shadows%20indoor%20lifestyle%20photography%20intimate%20relaxing%20atmosphere%20editorial%20quality%20neutral%20earthy%20tones&width=600&height=750&seq=about-lifestyle-v3&orientation=portrait')`,
              }}
            />
          </div>

          <div className="w-full lg:w-3/5">
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 leading-tight mb-5">
              What Is Superbuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              The Superbuy Spreadsheet is a carefully curated database of product finds from top
              Chinese marketplaces like Taobao and Weidian. Instead of spending hours manually
              searching through endless listings, you get instant access to organized product links
              with QC photos, sizing references, and price comparisons — all updated regularly.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Whether you are a beginner just starting your shopping journey or an experienced buyer
              looking for the latest trends, this spreadsheet saves you time and helps you discover
              products that the community has already vetted and approved.
            </p>

            <div className="overflow-x-auto mb-7">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b border-background-300">
                    <th className="text-left py-2.5 pr-4 text-foreground-800 font-semibold">Method</th>
                    <th className="text-left py-2.5 pr-4 text-foreground-800 font-semibold">Search Time</th>
                    <th className="text-left py-2.5 pr-4 text-foreground-800 font-semibold">Organization</th>
                    <th className="text-left py-2.5 text-foreground-800 font-semibold">Accuracy</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-background-200">
                    <td className="py-2.5 pr-4 text-foreground-600">Manual Search</td>
                    <td className="py-2.5 pr-4 text-foreground-500">High</td>
                    <td className="py-2.5 pr-4 text-foreground-500">Low</td>
                    <td className="py-2.5 text-foreground-500">Medium</td>
                  </tr>
                  <tr className="border-b border-background-200">
                    <td className="py-2.5 pr-4 text-foreground-600">Social Media</td>
                    <td className="py-2.5 pr-4 text-foreground-500">Medium</td>
                    <td className="py-2.5 pr-4 text-foreground-500">Low</td>
                    <td className="py-2.5 text-foreground-500">Unknown</td>
                  </tr>
                  <tr>
                    <td className="py-2.5 pr-4 text-primary-700 font-semibold">Superbuy Spreadsheet</td>
                    <td className="py-2.5 pr-4 text-primary-600 font-medium">Low</td>
                    <td className="py-2.5 pr-4 text-primary-600 font-medium">High</td>
                    <td className="py-2.5 text-primary-600 font-medium">Better</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <a
              href="/superbuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap"
            >
              Read Full Guide
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}